<template>
  <RouterView />
</template>

<script setup>
import { useTokenStore, useEnvStore } from '@/stores'
import { getHttpsAddress } from '@/utils/index'
import { detectEnvironment, getPlatform } from '@/utils/env'  // 引入环境检测

const { setToken, setRefreshtoken } = useTokenStore()
const { setEnv, removeAll } = useEnvStore()

const router = useRouter()

onMounted(() => {
  removeAll();
  // 获取网址中的token参数的值
  const token = new URL(window.location.href).searchParams.get('token')
  const refreshtoken = new URL(window.location.href).searchParams.get('refreshtoken')
  const env = new URL(window.location.href).searchParams.get('env')

  getHttpsAddress()
  
  if (token) {
    setEnv('mp')
    // 存储token
    localStorage.setItem('userToken', JSON.stringify({ token, refreshtoken }))
    setToken(token)
    setRefreshtoken(refreshtoken)
  } else if (env == 'js') {
    setEnv('js')
    router.push({ path: '/login' })
  }





  // // 检测运行环境
  // const utilsEnv = detectEnvironment()
  // console.log('🚀 ~ 运行环境:', utilsEnv)
  // console.log('🚀 ~ 平台标识:', getPlatform())
  // // alert(getPlatform())

  // // 根据环境执行不同逻辑
  // if (utilsEnv.isWechatMiniprogram) {
  //   console.log('当前在微信小程序环境中')
  //   // alert('当前在微信小程序环境中')
  //   setEnv('mp')
  //   // 小程序特有逻辑
  // } else if (utilsEnv.isApp) {
  //   console.log('当前在 APP 环境中')
  //   // alert('当前在 APP 环境中')
  //   setEnv('app')
  //   // APP 特有逻辑
  // } else {

  //   // 网页特有逻辑
  // }



  // 林
  // const token =
  //   'eyJhbGciOiJIUzUxMiJ9.eyJ1c2VySnNvbiI6IntcImlkXCI6NDAsXCJwbGF0Zm9ybUNvbnN0YW50XCI6XCJXRUNIQVRfUFJPR1JBTVwiLFwiZXhwaXJlc0F0XCI6MTc2Njk5MjUzMTU5MyxcInJlbWVtYmVyXCI6dHJ1ZX0iLCJleHAiOjE3NjY5OTI1MzF9.SJ8fONy2uk3Qk2jf0q5TC8g7m6RHqTv7lWkEq6sH5kM4FB13sBImfjOK1zu50nKo4kmWFPGHvUidynEkuThfew'
  // const refreshtoken = 'feca5cdbb9448e752a73f7632b3b6b8e'

  // 沈
  // const token =
  //   'eyJhbGciOiJIUzUxMiJ9.eyJ1c2VySnNvbiI6IntcImlkXCI6MzksXCJwbGF0Zm9ybUNvbnN0YW50XCI6XCJXRUNIQVRfUFJPR1JBTVwiLFwiZXhwaXJlc0F0XCI6MTc2Njg0MDczODYwNixcInJlbWVtYmVyXCI6dHJ1ZSxcIm51bWVueElkXCI6XCJOTTAxMjUxMjI0MDAwMDEwXCJ9IiwiZXhwIjoxNzY2ODQwNzM4fQ.9js_ggtg9hAy51kQg_ib9kznBZMrrBp9B9y4-OsKWo6BwsMM3LvUrIPVGNvU_7qXpTAUzaD_Dx_aQN_ze6Dqiw'
  // const refreshtoken = '8b39aa37afccb71328cd142351eea638'

})
</script>

<style scoped lang="scss"></style>
